import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Configuración de un proveedor de notificaciones para una app.
 * El backend puede devolver campos adicionales (credenciales, remitente, etc.);
 * se conservan tal cual y solo se modifica `enabled` desde este panel.
 */
export interface ProviderConfig {
  providerId: string;
  enabled: boolean;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class AppNotificationsService {
  private baseUrl: string = environment.notifications_api.base_url;

  constructor(private http: HttpClient) {}

  private emailConfigUrl(appId: string): string {
    return `${this.baseUrl}/app-config/${appId}/email`;
  }

  getEmailConfig(appId: string): Observable<ProviderConfig> {
    return this.http.get<ProviderConfig>(this.emailConfigUrl(appId));
  }

  setEmailConfig(appId: string, config: ProviderConfig): Observable<ProviderConfig> {
    return this.http.put<ProviderConfig>(this.emailConfigUrl(appId), config);
  }
}
